/**
 * @title Api Documentation
 * @description Api Documentation
 * @version 1.0
 *
 * Swagger version 2.0
 * Generated at: Fri Mar 26 2021 13:32:44 GMT+0100 (czas środkowoeuropejski standardowy)
 */

import { API_URLS } from '../utils/config';
import { request } from '../utils/request';
import prepareQueryParams from 'utils/prepareQueryParams';
import { AssetRVCriteria } from './pricing';

const URL = API_URLS.ASSETS_CONFIG;

export interface AbstractResponse<D, L> {
  code: string;
  data: D;
  description: string;
  list: Array<L>;
  message: string;
}

export interface AssetCatalogComponentResponse {
  assetid: number;
  compcategory: string;
  compcategorylabel: string;
  compdescription: string;
  compdiscountamount: number;
  compdiscountrate: number;
  compfree1: string;
  compgrossamount: number;
  compid: number;
  compnetamount: number;
  comporiginalnetamount: number;
  comptaxamount: number;
  comptype: string;
  comptypelabel: string;
  taxcode: string;
  taxrate: number;
  tpidsupplier: number;
  suppliername: string;
  supplierreference: string;
  flagholdback: boolean;
  holdbackpercentage: number;
  holdbackamount: number;
  holdbackbeleasenbdays: number;
  holdbackbeleasedate: string;
}

export interface ViewEntityAddAttributeResponse {
  assetcategory: string;
  assetfamily: string;
  assettype: string;
  attbooleanvalue: boolean;
  attcode: string;
  attlabel?: string;
  attcodeparent: string;
  attdatatype: string;
  attinputtype: string;
  attnbrows: number;
  attnumericvalue: number;
  attstringvalue: string;
  atttextvalue: string;
  colspan: number;
  defautvalue: string;
  displayorder: number;
  displayposition: string;
  displaysection: string;
  displaytype: string;
  entity: string;
  entityid: number;
  entitytype: string;
  maxvalue: string;
  minvalue: string;
  parcode: string;
  prcode: string;
  style: string;
}

export interface GetEntityAdditionaAttributesParams {
  assetcategory: string;
  assetfamily: string;
  assettype: string;
  assetsegment: string;
  assetmodel: string;
  entity: string;
  entityid: number;
  entitytype: string;
  prcode: string;
}

/**
 * @tags Asset Controller
 * @summary getEntityAdditionaAttributes
 */
export function getCatalogAdditionalAttributes(
  params: GetEntityAdditionaAttributesParams
) {
  return request.get<AbstractResponse<object, ViewEntityAddAttributeResponse>>(
    `${URL}/api/assetCatalog/additionalattribute` +
      prepareQueryParams({
        assetcategory: params.assetcategory,
        assetfamily: params.assetfamily,
        assettype: params.assettype,
        assetsegment: params.assetsegment,
        assetmodel: params.assetmodel,
        entity: params.entity,
        entityid: params.entityid,
        entitytype: params.entitytype,
        prcode: params.prcode,
      } as any)
  );
}

export interface AssetCatalogResponse {
  assetid:number;
  assettaggrouping: string;
  assetCatalogComponents: Array<AssetCatalogComponentResponse>;
  assetCatalogOptions: Array<ParAssetCatalogOptionResponse>;
  assetCatalogServices: Array<ParAssetCatalogServiceResponse>;
  entityAddAttribut?: Array<ViewEntityAddAttributeResponse>;
  assetDowngradeList: Array<AssetCatalogUpgradeResponse>;
  assetUpgradeList: Array<AssetCatalogUpgradeResponse>;
  tpidmanufacturer: number;
  manufacturerreference: string;
  manufacturername: string;
  catalogidlinked: number;
  catalogidlinkedlabel: string;
  catalogidorigine: number;
  catalogidoriginelabel: string;
  power: string;
  weight: string;
  assetcategory: string;
  assetcategorylabel: string;
  assetconstructor: string;
  assetconstructorreference: string;
  assetdescription: string;
  assetdiscountamount: number;
  assetdiscountperc: number;
  assetgrossamount: number;
  assetgrossamountorigine: number;
  assetlabel: string;
  assetmodel: string;
  assetmodellabel: string;
  assetmulticomponents: boolean;
  assetnetamount: number;
  assetnetamountorigine: number;
  assetpictureurl: string;
  assetpictureurl2: string;
  assetpictureurl3: string;
  assetpictureurl4: string;
  assetpictureurl5: string;
  assetpictureurl6: string;
  assetstatuslabel: string;
  statuslabel?: string;
  assettaxamount: number;
  assetsegment: string;
  assetsegmentlabel: string;
  assettype: string;
  assettypelabel: string;
  assetvariant: string;
  assetversion: string;
  catalogid: number;
  catalogstatus: string;
  enddate: string;
  flagwebshop: boolean;
  mcid: number;
  mclabel: string;
  mgid: number;
  networkcode: string;
  startdate: string;
  suppliername: string;
  taxcode: string;
  taxrate: number;
  tpidbroker: number;
  tpidsupplier: number;
  brokername: string;
  brokerreference: string;
  supplierreference: string;
  currcode: string;
  assetfamilylabel: string;
  assetfamily: string;
  assetclass: string;
  flagholdback: boolean;
  holdbackpercentage: number;
  holdbackamount: number;
  holdbackbeleasenbdays: number;
  holdbackbeleasedate: string;
  kwhpower: number;
  kwhproduction: number;
  kwhdegradation: number;
  chassisno?: string;
  assetfinamount: number;
  degfeesformula: number;
  spfeesformula: number;
  tpofformula: number;
  deliverydelay: string;
  age?: number;
  balersize?: string;
  balersizelabel?: string;
  separatortype?: string;
  separatortypelabel?: string;
  wheeldrive?: string;
  wheeldrivelabel?: string;
  transmission?: string;
  transmissionlabel?: string;
  wheeltrack?: string;
  lift?: number;
  capacity?: number;
  tankcapacity?: number;
  nbcampaign?: number;
  threshinghours?: number;
  rotorhours?: number;
  totalhours?: number;
  totalbalers?: number;
  country?: string;
  countrylabel?: string;
  partmethod?: string;
  partamount?: number;
  partrate?: number;
  tpidparticipation?: number;
  participantname?: string;
  participantreference?: string;
  partnbdays?: number;
  rolcode?: string;
  partmethodlabel?: string;
  rolcodelabel?: string;
  id?: number;
  registrationdate?: string;
  registrationcity?: string;
  registrationname?: string;
  firstregistrationdate?: string;
  fiscalpower?: number;
}

export interface AssetCatalogUpgradeResponse {
  assetlabel: string;
  assetnetamount: number;
  catalogid: number;
}

export interface ParAssetCatalogUpgrade {
  catalogid: number;
  catalogidupgrade: number;
  upid: number;
}

export interface MgParAssetCatalogResponse {
  catalogid: number;
  filterid: number;
  mgid: number;
  mgname: string;
}

export interface MgParAssetCatalog {
  catalogid: number;
  filterid: number;
  mgid: number;
}

export interface EntityAdditionalAttributeRequest {
  attbooleanvalue: boolean | null;
  attcode: string;
  attnumericvalue: number;
  attstringvalue: string;
  atttextvalue: string;
  entity: string;
  entityid: number;
  id: number;
}

export interface ParAssetCatalog {
  assetCatalogComponents: Array<ParAssetCatalogComponent>;
  entityAddAttributList: Array<EntityAdditionalAttributeRequest>;
  power: string;
  weight: string;
  assetsegment: string;
  assetcategory: string;
  assetconstructor: string;
  assetconstructorreference: string;
  assetdescription: string;
  assetdiscountamount: number;
  assetdiscountperc: number;
  assetgrossamount: number;
  assetgrossamountorigine: number;
  assetlabel: string;
  assetmodel: string;
  assetmulticomponents: boolean;
  assetnetamount: number;
  assetnetamountorigine: number;
  assetpictureurl: string;
  assetpictureurl2: string;
  assetpictureurl3: string;
  assetpictureurl4: string;
  assetpictureurl5: string;
  assetpictureurl6: string;
  assettaxamount: number;
  assettype: string;
  assetvariant: string;
  catalogid: number;
  catalogstatus: string;
  enddate: string;
  flagwebshop: boolean;
  mcid: number;
  mgid: number;
  networkcode: string;
  startdate: string;
  taxcode: string;
  taxrate: number;
  tpidbroker: number;
  tpidsupplier: number;
  brokername: string;
  brokerreference: string;
  supplierreference: string;
  currcode: string;
  kwhpower: number;
  kwhproduction: number;
  kwhdegradation: number;
  last_action: number;
}

export interface ParAssetCatalogComponent {
  assetCatalog: ParAssetCatalog;
  compcategory: string;
  compdescription: string;
  compdiscountamount: number;
  compdiscountrate: number;
  compfree1: string;
  compgrossamount: number;
  compid: number;
  compnetamount: number;
  comporiginalnetamount: number;
  comptaxamount: number;
  comptype: string;
  taxcode: string;
  taxrate: number;
}

export interface ParAssetCatalogCriteria {
  catalogid: number;
  criid: number;
  critcode: string;
  critvalue: string;
}

export interface ParAssetCatalogAmountResponse {
  associd: number;
  creationdate: string;
  enddate: string;
  entityamount: number;
  entityid: number;
  entitytype: string;
  startdate: string;
  taskid: number;
  useridcreation: number;
}
export interface ParAssetCatalogCriteriaResponse {
  catalogid: number;
  criid: number;
  critcode: string;
  critcodelabel: string;
  critvalue: string;
  critvaluelabel: string;
}

export interface ParAssetCatalogLabel {
  assetdescription: string;
  assetlabel: string;
  assettaglabel: string;
  catalogid: number;
  labelid: number;
  lancode: string;
}

export interface ParAssetCatalogOption {
  catalogid: number;
  optcode: string;
  optgrossamount: number;
  optid: number;
  optnetamount: number;
  optpictureurl: string;
  optpictureurl2: string;
  optpictureurl3: string;
  optpictureurl4: string;
  optpictureurl5: string;
  optpictureurl6: string;
  opttaxamount: number;
  opttaxcode: string;
  optvalue: string;
  flagfreelabel: boolean;
  flagtopropose: boolean;
}

export interface ParAssetCatalogOptionResponse {
  catalogid: number;
  optcode: string;
  optcodelabel: string;
  optgrossamount: number;
  optid: number;
  optnetamount: number;
  optpictureurl: string;
  optpictureurl2: string;
  optpictureurl3: string;
  optpictureurl4: string;
  optpictureurl5: string;
  optpictureurl6: string;
  opttaxamount: number;
  opttaxcode: string;
  optvalue: string;
  optvaluelabel: string;
  flagfreelabel: boolean;
  flagtopropose: boolean;
  startdate: string;
  enddate: string;
  proposed: boolean;
}

export interface ParAssetCatalogPicture {
  displayorder: number;
  objectid: number;
  objecttype: string;
  picid: number;
  picturename: string;
  picturetype: string;
  pictureurl: string;
}

export interface ParAssetCatalogService {
  associd: number;
  catalogid: number;
  servcode: string;
  servfixedamount: number;
  servpercentage: number;
}

export interface ParAssetCatalogServiceResponse {
  associd: number;
  assetid?: number;
  catalogid: number;
  servcode: string;
  servfixedamount: number;
  servfixedamountdefault: number;
  servlabel: string;
  servpercentage: number;
  servpercentagedefault: number;
  servuseunit:string;
  servusefrequency:string;
  servuseunitlabel:string;
  servusefrequencylabel:string;

  servuseqty:number;
  servuseminamount:number;
  servusemaxamount:number;
  servusecoverage:number;
  servusedeductionamount:number;
  servusedeductionpercenrage:number;
  servdescription:string,
  cteid:number;
	startdate:string;
	enddate:string;
	status:string;
}

export interface GetAssetCatalogListByCriteriaParams {
  catalogid: number;
  category: string;
  assetconstructor: string;
  label: string;
  mcid: number;
  mgid: number;
  model: string;
  networkcode: string;
  reference: string;
  status: string;
  tpidbroker: number;
  tpidsupplier: number;
  type: string;
  variant: string;
  tpidmanufacturer: number;
}

export interface AssetFutureValueScheduleResponse {
  finrvamount: number;
  fvamount: number;
  fvdate: string;
  fvid: number;
  fvpercentage: number;
  fvstatus: string;
  proctaskid: number;
  parfvid: number;
}

export interface AssetFutureValueContextUseResponse {
  attcode: string;
  attcodelabel: string;
  fvuseid: number;
  usevalue: number;
}

export interface AssetFutureValueResponse {
  fvContextUse: Array<AssetFutureValueContextUseResponse>;
  fvSchedule: Array<AssetFutureValueScheduleResponse>;
  assetid: number;
  contextcode: string;
  contextcodelabel: string;
  contextid: number;
  contextidorigine: number;
  contextidoriginelabel: string;
  contextorigin: string;
  contextoriginelabel: string;
  contextstatus: string;
  contextstatuslabel: string;
  creationdate: string;
  duration: number;
  fvtype: string;
  fvtypelabel: string;
  offerid: number;
  offerlabel: string;
  ofrid: number;
  ofrlabel: string;
  ofrtype: string;
  ofrtypelabel: string;
  parcontextid: number;
  prcode: string;
  prcodelabel: string;
  useridcreation: number;
}

export interface GetAssetCatalogByKeywordParams {
  filters: string;
  keyword: string;
  mcid: number;
  mgid: number;
  networkcode: string;
  tpidbroker: number;
  tpidmanufacturer?: number;
  currcode: string;
  flagwebshop: boolean;
}

export interface AssetUseConditionRequest {
  attcode: string;
  usevalue: number;
  usevaluedate: string;
}

export interface PaymentSchedule {
  ctsorder: number;
  ctstype: string;
  ctsterm: string;
  ctsperiodicity: number; // 1, 3, 12...,
  ctsperiodicityunit: string; // Day / Month
  ctsduedate: string;
  ctsstartdate: string;
  ctsenddate: string;
  ctsstartamount: number;
  ctsamortizedamount: number;
  ctsinterestamount: number;
  ctsrentalamount: number;
  ctsoutstandingamount: number;
}

export interface AssetFVCalculationParams {
  parcontextid: number;
  assetid: number;
  contextid: number;
  duration: number;
  mode: string; // INIT : simulation, MVUPDATE : Update of a contextid with a new Market Value, USEUPDATE : Update of a contextid with a useCondition
  newmarketvalue: number; // mandatory if mode = MVUPDATE
  newvaluedate: string; // mandatory if mode != INIT
  proctaskid: number; // mandatory if mode != INIT
  useCondition: Array<AssetUseConditionRequest>; // mandatory if mode = USEUPDATE
  paymentSchedule: Array<PaymentSchedule>; // INIT MODE : nice to have : to adjust FV dates with PaymentSchedule dates
  assetnetamount: number; // to use when simulate FV for AssetCatalog. in that case, assetid is not mandatory
}

/**
 * @tags Pricing Controller
 * @summary getAssetCatalogByKeyword
 */
export function getAssetCatalogByKeyword(
  params: GetAssetCatalogByKeywordParams
) {
  return request.get<AbstractResponse<object, AssetCatalogResponse>>(
    `${URL}/api/prGetAssetCatalogByKeyword` +
      prepareQueryParams({
        filters: params.filters,
        keyword: params.keyword,
        mcid: params.mcid,
        mgid: params.mgid,
        networkcode: params.networkcode,
        tpidbroker: params.tpidbroker,
        currcode: params.currcode,
        flagwebshop: params.flagwebshop,
        tpidmanufacturer: params.tpidmanufacturer,
      } as any)
  );
}

export interface CalculateAssetFutureValueParams {
  request: AssetFVCalculationParams;
}

export function calculateAssetCatalogFutureValue(
  params: CalculateAssetFutureValueParams
) {
  return request.post<AbstractResponse<AssetFutureValueResponse, object>>(
    `${URL}/api/assetCatalog/futureValue/calculate`,
    params.request
  );
}

export interface RemoveAssetCatalogAmountParams {
  associd: number;
}

/**
 * @tags Pricing Controller
 * @summary removeAssetCatalogAmount
 */
export function removeAssetCatalogAmount(
  params: RemoveAssetCatalogAmountParams
) {
  return request.delete<AbstractResponse<object, object>>(
    `${URL}/api/assetCatalog/option/${params.associd}`
  );
}

export interface GetAssetCatalogAmountListParams {
  entityid: number;
  entitytype: string;
}

/**
 * @tags Pricing Controller
 * @summary getAssetCatalogAmountList
 */
export function getAssetCatalogAmountList(
  params: GetAssetCatalogAmountListParams
) {
  return request.get<AbstractResponse<object, ParAssetCatalogAmountResponse>>(
    `${URL}/api/assetCatalog/${params.entityid}/amount/${params.entitytype}`
  );
}

export interface UpdateAssetCatalogAmountParams {
  req: ParAssetCatalogAmountResponse;
  catalogid: number;
  associd: number;
}

/**
 * @tags Pricing Controller
 * @summary updateAssetCatalogAmount
 */
export function updateAssetCatalogAmount(
  params: UpdateAssetCatalogAmountParams
) {
  return request.put<AbstractResponse<object, object>>(
    `${URL}/api/assetCatalog/${params.catalogid}/amount/${params.associd}`,
    params.req
  );
}

export interface AddAssetCatalogAmountParams {
  req: ParAssetCatalogAmountResponse;
  catalogid: number;
}

/**
 * @tags Pricing Controller
 * @summary addAssetCatalogAmount
 */
export function addAssetCatalogAmount(params: AddAssetCatalogAmountParams) {
  return request.post<AbstractResponse<object, object>>(
    `${URL}/api/assetCatalog/${params.catalogid}/amount`,
    params.req
  );
}

/**
 * @tags Pricing Controller
 * @summary getAssetCatalogByKeyword
 */
export function getAssetCatalogByKeywordOfferOrPricing(
  params: GetAssetCatalogByKeywordOfferOrPricingParams
) {
  return request.get<AbstractResponse<object, AssetCatalogResponse>>(
    `${URL}/api/prGetAssetCatalogByKeywordAndOfferOrPricing` +
      prepareQueryParams({
        filters: params.filters,
        keyword: params.keyword,
        mcid: params.mcid,
        mgid: params.mgid,
        networkcode: params.networkcode,
        tpidbroker: params.tpidbroker,
        currcode: params.currcode,
        offerid: params.offerid,
        opid: params.opid,
      } as any)
  );
}

export interface GetAssetCatalogByKeywordOfferOrPricingParams {
  filters: string;
  keyword: string;
  mcid: number;
  mgid: number;
  networkcode: string;
  tpidbroker: number;
  currcode: string;
  offerid: number;
  opid: number;
}

export interface AssetRVAmountResponse {
  rvid: number;
  mgid: number;
  assetid: number;
  prcode: string;
  assettype: string;
  assetcategory: string;
  assetamount: number;
  monthsmin: number;
  monthsmax: number;
  rvevaluationmode: string;
  rvfixedamount: number;
  rvpercentage: number;
  rvamount: number;
}

export function getAssetCatalogOrAssetPackByKeyword(
  params: GetAssetCatalogByKeywordParams
) {
  return request.get<AbstractResponse<object, ParMarketingResponse>>(
    `${URL}/api/prGetAssetCatalogOrAssetPackByKeyword` +
      prepareQueryParams({
        filters: params.filters,
        keyword: params.keyword,
        mcid: params.mcid,
        mgid: params.mgid,
        networkcode: params.networkcode,
        tpidbroker: params.tpidbroker,
        currcode: params.currcode,
        flagwebshop: params.flagwebshop,
      } as any)
  );
}
export interface UpdateAssetCatalogStatusParams {
  catalogid: number;
  status: string;
}

/**
 * @tags Pricing Controller
 * @summary updateAssetCatalogStatus
 */
export function updateAssetCatalogStatus(
  params: UpdateAssetCatalogStatusParams
) {
  return request.put<AbstractResponse<AssetCatalogResponse, object>>(
    `${URL}/api/assetCatalog/${params.catalogid}/updateStatus/${params.status}`
  );
}

export interface UpdateAssetCatalogPicturePathParams {
  catalogid: number;
  picid: number;
  picname: string;
}

/**
 * @tags Pricing Controller
 * @summary updateAssetCatalogPicturePath
 */
export function updateAssetCatalogPicturePath(
  params: UpdateAssetCatalogPicturePathParams
) {
  return request.put<AbstractResponse<AssetCatalogResponse, object>>(
    `${URL}/api/assetCatalog/${params.catalogid}/updatePicturePath/${params.picid}/${params.picname}`
  );
}

export interface RemoveAssetCatalogServiceParams {
  associd: number;
  catalogid: number;
}

/**
 * @tags Pricing Controller
 * @summary removeAssetCatalogService
 */
export function removeAssetCatalogService(
  params: RemoveAssetCatalogServiceParams
) {
  return request.delete<AbstractResponse<object, object>>(
    `${URL}/api/assetCatalog/${params.catalogid}/service/${params.associd}`
  );
}

export interface UpdateAssetCatalogServiceParams {
  req: ParAssetCatalogService;
  catalogid?: number;
}

/**
 * @tags Pricing Controller
 * @summary updateAssetCatalogService
 */
export function updateAssetCatalogService(
  params: UpdateAssetCatalogServiceParams
) {
  return request.put<AbstractResponse<object, object>>(
    `${URL}/api/assetCatalog/${params.catalogid}/service`,
    params.req
  );
}

export interface AddAssetCatalogServiceParams {
  req: ParAssetCatalogService;
  catalogid?: number;
}

/**
 * @tags Pricing Controller
 * @summary addAssetCatalogService
 */
export function addAssetCatalogService(params: AddAssetCatalogServiceParams) {
  return request.post<AbstractResponse<object, object>>(
    `${URL}/api/assetCatalog/${params.catalogid}/service`,
    params.req
  );
}

export interface GetAssetCatalogServiceListParams {
  catalogid: number;
}

/**
 * @tags Pricing Controller
 * @summary getAssetCatalogServiceList
 */
export function getAssetCatalogServiceList(
  params: GetAssetCatalogServiceListParams
) {
  return request.get<AbstractResponse<object, ParAssetCatalogServiceResponse>>(
    `${URL}/api/assetCatalog/${params.catalogid}/service`
  );
}

export interface RemoveAssetCatalogPictureParams {
  catalogid: number;
  picid: number;
}

/**
 * @tags Pricing Controller
 * @summary removeAssetCatalogPicture
 */
export function removeAssetCatalogPicture(
  params: RemoveAssetCatalogPictureParams
) {
  return request.delete<AbstractResponse<object, object>>(
    `${URL}/api/assetCatalog/${params.catalogid}/picture/${params.picid}`
  );
}

export interface AddAssetCatalogPictureParams {
  req: ParAssetCatalogPicture;
  catalogid?: number;
}

/**
 * @tags Pricing Controller
 * @summary addAssetCatalogPicture
 */
export function addAssetCatalogPicture(params: AddAssetCatalogPictureParams) {
  return request.post<AbstractResponse<object, object>>(
    `${URL}/api/assetCatalog/${params.catalogid}/picture`,
    params.req
  );
}

/**
 * @tags Pricing Controller
 * @summary getAssetCatalogCriteria
 */
export function getAssetCatalogCriteria(params: GetAssetCatalogCriteriaParams) {
  return request.get<AbstractResponse<object, ParAssetCatalogCriteriaResponse>>(
    `${URL}/api/assetCatalog/${params.catalogid}/criteria`
  );
}

export interface AddAssetCatalogCriteriaParams {
  req: ParAssetCatalogCriteria;
  catalogid?: number;
}

/**
 * @tags Pricing Controller
 * @summary addAssetCatalogCriteria
 */
export function addAssetCatalogCriteria(params: AddAssetCatalogCriteriaParams) {
  return request.post<AbstractResponse<object, object>>(
    `${URL}/api/assetCatalog/${params.catalogid}/criteria`,
    params.req
  );
}

export interface RemoveAssetCatalogCriteriaParams {
  catalogid: number;
  criid: number;
}

/**
 * @tags Pricing Controller
 * @summary removeAssetCatalogCriteria
 */
export function removeAssetCatalogCriteria(
  params: RemoveAssetCatalogCriteriaParams
) {
  return request.delete<AbstractResponse<object, object>>(
    `${URL}/api/assetCatalog/${params.catalogid}/criteria/${params.criid}`
  );
}

export interface DuplicateAssetCatalogParams {
  catalogid: number;
  catalogidorigine: number;
  isnewVersion: boolean;
}

/**
 * @tags Pricing Controller
 * @summary duplicateAssetCatalog
 */
export function duplicateAssetCatalog(params: DuplicateAssetCatalogParams) {
  return request.get<AbstractResponse<AssetCatalogResponse, object>>(
    `${URL}/api/assetCatalog/${params.catalogid}/duplicate` +
      prepareQueryParams({
        catalogidorigine: params.catalogidorigine,
        isnewVersion: params.isnewVersion,
      } as any)
  );
}

export interface GetAssetCatalogLabelListParams {
  catalogid: number;
}

/**
 * @tags Pricing Controller
 * @summary getAssetCatalogLabelList
 */
export function getAssetCatalogLabelList(
  params: GetAssetCatalogLabelListParams
) {
  return request.get<AbstractResponse<object, ParAssetCatalogLabel>>(
    `${URL}/api/assetCatalog/${params.catalogid}/label`
  );
}

export interface AddAssetCatalogLabelParams {
  req: ParAssetCatalogLabel;
  catalogid?: number;
}

/**
 * @tags Pricing Controller
 * @summary addAssetCatalogLabel
 */
export function addAssetCatalogLabel(params: AddAssetCatalogLabelParams) {
  return request.post<AbstractResponse<object, object>>(
    `${URL}/api/assetCatalog/${params.catalogid}/label`,
    params.req
  );
}

export interface UpdateAssetCatalogLabelParams {
  req: ParAssetCatalogLabel;
  catalogid?: number;
}

/**
 * @tags Pricing Controller
 * @summary updateAssetCatalogLabel
 */
export function updateAssetCatalogLabel(params: UpdateAssetCatalogLabelParams) {
  return request.put<AbstractResponse<object, object>>(
    `${URL}/api/assetCatalog/${params.catalogid}/label`,
    params.req
  );
}

export interface RemoveAssetCatalogLabelParams {
  catalogid: number;
  labelid: number;
}

/**
 * @tags Pricing Controller
 * @summary removeAssetCatalogLabel
 */
export function removeAssetCatalogLabel(params: RemoveAssetCatalogLabelParams) {
  return request.delete<AbstractResponse<object, object>>(
    `${URL}/api/assetCatalog/${params.catalogid}/label/${params.labelid}`
  );
}

export interface GetAssetCatalogOptionListParams {
  catalogid: number;
}

/**
 * @tags Pricing Controller
 * @summary getAssetCatalogOptionList
 */
export function getAssetCatalogOptionList(
  params: GetAssetCatalogOptionListParams
) {
  return request.get<AbstractResponse<object, ParAssetCatalogOptionResponse>>(
    `${URL}/api/assetCatalog/${params.catalogid}/option`
  );
}

export interface AddAssetCatalogOptionParams {
  req: ParAssetCatalogOption;
  catalogid?: number;
}

/**
 * @tags Pricing Controller
 * @summary addAssetCatalogOption
 */
export function addAssetCatalogOption(params: AddAssetCatalogOptionParams) {
  return request.post<AbstractResponse<object, object>>(
    `${URL}/api/assetCatalog/${params.catalogid}/option`,
    params.req
  );
}

export interface UpdateAssetCatalogOptionParams {
  req: ParAssetCatalogOption;
  catalogid?: number;
}

/**
 * @tags Pricing Controller
 * @summary updateAssetCatalogOption
 */
export function updateAssetCatalogOption(
  params: UpdateAssetCatalogOptionParams
) {
  return request.put<AbstractResponse<object, object>>(
    `${URL}/api/assetCatalog/${params.catalogid}/option`,
    params.req
  );
}

export interface RemoveAssetCatalogOptionParams {
  catalogid: number;
  optid: number;
}

/**
 * @tags Pricing Controller
 * @summary removeAssetCatalogOption
 */
export function removeAssetCatalogOption(
  params: RemoveAssetCatalogOptionParams
) {
  return request.delete<AbstractResponse<object, object>>(
    `${URL}/api/assetCatalog/${params.catalogid}/option/${params.optid}`
  );
}

export interface GetAssetCatalogRvAmountListParams {
  catalogid: number;
  prcode: string;
  assetamount: number;
  filters: prFilteringCriteria;
}

export interface UpdateAssetCatalogOptionPicturePathParams {
  catalogid: number;
  optid: number;
  picid: number;
  picname: string;
}

/**
 * @tags Pricing Controller
 * @summary updateAssetCatalogOptionPicturePath
 */
export function updateAssetCatalogOptionPicturePath(
  params: UpdateAssetCatalogOptionPicturePathParams
) {
  return request.put<AbstractResponse<object, object>>(
    `${URL}/api/assetCatalog/${params.catalogid}/option/${params.optid}/updatePicturePath/${params.picid}/${params.picname}`
  );
}

export interface GetAssetCatalogPictureListParams {
  catalogid: number;
}

/**
 * @tags Pricing Controller
 * @summary getAssetCatalogPictureList
 */
export function getAssetCatalogPictureList(
  params: GetAssetCatalogPictureListParams
) {
  return request.get<AbstractResponse<object, ParAssetCatalogPicture>>(
    `${URL}/api/assetCatalog/${params.catalogid}/picture`
  );
}

export function getAssetCatalogRvAmountList(
  params: GetAssetCatalogRvAmountListParams
) {
  return request.post<AbstractResponse<AssetRVAmountResponse, object>>(
    `${URL}/api/getAssetCatalogRvAmountList` +
      prepareQueryParams({
        catalogid: params.catalogid,
        prcode: params.prcode,
        assetamount: params.assetamount,
      } as any),
    params.filters
  );
}

export interface UpdateAssetCatalogRVParams {
  request: ParAssetCatalogResidualValue;
  rvid: number;
}

/**
 * @tags Pricing Controller
 * @summary updateAssetCatalogRV
 */
export function updateAssetCatalogRV(params: UpdateAssetCatalogRVParams) {
  return request.put<AbstractResponse<object, ParAssetCatalogResidualValue>>(
    `${URL}/api/assetcatalogrv/${params.rvid}`,
    params.request
  );
}

export interface DeleteAssetCatalogRVParams {
  rvid: number;
}

/**
 * @tags Pricing Controller
 * @summary deleteAssetCatalogRV
 */
export function deleteAssetCatalogRV(params: DeleteAssetCatalogRVParams) {
  return request.delete<AbstractResponse<object, object>>(
    `${URL}/api/assetcatalogrv/${params.rvid}`
  );
}

export interface GetAssetCatalogRVByCatalogIDParams {
  catalogid: number;
  rvtype: string;
  prcode: string;
}

/**
 * @tags Pricing Controller
 * @summary getAssetCatalogRVByCatalogID
 */
export function getAssetCatalogRVByCatalogID(
  params: GetAssetCatalogRVByCatalogIDParams
) {
  return request.get<AbstractResponse<ParAssetCatalogResidualValue, object>>(
    `${URL}/api/assetcatalogrvList/${params.catalogid}/${params.prcode}/${params.rvtype}`
  );
}

export interface ParAssetCatalogResidualValue {
  catalogid: number;
  monthsmax: number;
  monthsmin: number;
  prcode: string;
  rvevaluationmode: string;
  rvfixedamount: number;
  rvid: number;
  rvpercentage: number;
  trg: number;
  rvtype: string;
  monthdecrease: number;
  rvstartmethod: string;
  countrvid: number;
  mileagemin:number;
  mileagemax:number;
  exceedformula:number;
}

export interface AddAssetCatalogRVParams {
  request: ParAssetCatalogResidualValue;
}

/**
 * @tags Pricing Controller
 * @summary addAssetCatalogRV
 */
export function addAssetCatalogRV(params: AddAssetCatalogRVParams) {
  return request.post<AbstractResponse<object, ParAssetCatalogResidualValue>>(
    `${URL}/api/assetcatalogrv`,
    params.request
  );
}

export interface CreateAssetCatalogParams {
  req: ParAssetCatalog;
}

/**
 * @tags Pricing Controller
 * @summary createAssetCatalog
 */
export function createAssetCatalog(params: CreateAssetCatalogParams) {
  return request.post<AbstractResponse<AssetCatalogResponse, object>>(
    `${URL}/api/assetCatalog`,
    params.req
  );
}

export interface UpdateAssetCatalogParams {
  req: ParAssetCatalog;
}

/**
 * @tags Pricing Controller
 * @summary updateAssetCatalog
 */
export function updateAssetCatalog(params: UpdateAssetCatalogParams) {
  return request.put<AbstractResponse<AssetCatalogResponse, object>>(
    `${URL}/api/assetCatalog`,
    params.req
  );
}

export interface GetAssetCatalogByIDParams {
  catalogid: number;
}

/**
 * @tags Pricing Controller
 * @summary getAssetCatalogByID
 */
export function getAssetCatalogByID(params: GetAssetCatalogByIDParams) {
  return request.get<AbstractResponse<AssetCatalogResponse, object>>(
    `${URL}/api/assetCatalog/${params.catalogid}`
  );
}

export interface GetAssetCatalogCriteriaParams {
  catalogid: number;
}

export function getAssetCatalogListByCriteria(
  params: GetAssetCatalogListByCriteriaParams
) {
  return request.get<AbstractResponse<object, AssetCatalogResponse>>(
    `${URL}/api/assetCatalog` +
      prepareQueryParams({
        catalogid: params.catalogid,
        category: params.category,
        constructor: params.assetconstructor,
        label: params.label,
        mcid: params.mcid,
        mgid: params.mgid,
        model: params.model,
        networkcode: params.networkcode,
        reference: params.reference,
        status: params.status,
        tpidbroker: params.tpidbroker,
        tpidsupplier: params.tpidsupplier,
        type: params.type,
        variant: params.variant,
        tpidmanufacturer: params.tpidmanufacturer,
      } as any)
  );
}
/**
 * @tags Pricing Controller
 * @summary getParAssetRVByCriteria
 */
export function getParAssetRVByCriteria(params: GetParAssetRVByCriteriaParams) {
  return request.get<AbstractResponse<object, ParAssetResidualValue>>(
    `${URL}/api/assetrv` +
      prepareQueryParams({
        assetcategory: params.assetcategory,
        assettype: params.assettype,
        mgid: params.mgid,
        prcode: params.prcode,
        rvtype: params.rvtype,
      } as any)
  );
}

export interface AddParAssetRVBParams {
  request: ParAssetResidualValue;
}

/**
 * @tags Pricing Controller
 * @summary addParAssetRVB
 */
export function addParAssetRVB(params: AddParAssetRVBParams) {
  return request.post<AbstractResponse<ParAssetResidualValue, object>>(
    `${URL}/api/assetrv`,
    params.request
  );
}

export interface UpdateParAssetRVBParams {
  request: ParAssetResidualValue;
  rvid: number;
}

/**
 * @tags Pricing Controller
 * @summary updateParAssetRVB
 */
export function updateParAssetRVB(params: UpdateParAssetRVBParams) {
  return request.put<AbstractResponse<ParAssetResidualValue, object>>(
    `${URL}/api/assetrv/${params.rvid}`,
    params.request
  );
}

export interface RemoveParAssetRVBParams {
  rvid: number;
}

/**
 * @tags Pricing Controller
 * @summary removeParAssetRVB
 */
export function removeParAssetRVB(params: RemoveParAssetRVBParams) {
  return request.delete<AbstractResponse<object, object>>(
    `${URL}/api/assetrv/${params.rvid}`
  );
}

/********************************************************************************* */
/***************************************************ParMarketing */
/********************************************************************************** */

export interface ParMarketingLabelResponse {
  mclabelPK: MCLabelPK;
  mcdescription: string;
  mclabel: string;
  picturebuttomlefturl: string;
  picturebuttomrighturl: string;
  picturecenterurl: string;
  picturemobileurl: string;
  picturetoplefturl: string;
  picturetoprighturl: string;
  pictureurl: string;
}

export interface ParMarketingResponse {
  parMarketingLabels: Array<ParMarketingLabelResponse>;
  assets: Array<AssetCatalogResponse>;
  currcode: string;
  assetnetamount: number;
  assettaxamount: number;
  assetgrossamount: number;
  enddate: string;
  mccode: string;
  mcid: number;
  mclabel: string;
  mcstatus: string;
  mcstatuslabel: string;
  mgid: number;
  networkcode: string;
  networklabel: string;
  picturebuttomlefturl: string;
  picturebuttomrighturl: string;
  picturecenterurl: string;
  picturemobileurl: string;
  picturetoplefturl: string;
  picturetoprighturl: string;
  pictureurl: string;
  prcode: string;
  prlabel: string;
  startdate: string;
  offerid: number;
  ofrtype: string;
  ofrid: number;

  offerlabel: string;
  ofrtypelabel: string;
  ofridlabel: string;
  tpidmanufacturer: number;
  manufacturername: string;
  manufacturerreference: string;
  tpidbroker: number;
  brokername: string;
  brokerreference: string;
}

export interface MCLabelPK {
  lancode: string;
  mcid: number;
}
export interface ParMarketingLabel {
  mclabelPK: MCLabelPK;
  mcdescription: string;
  mclabel: string;
  picturebuttomlefturl: string;
  picturebuttomrighturl: string;
  picturecenterurl: string;
  picturemobileurl: string;
  picturetoplefturl: string;
  picturetoprighturl: string;
  pictureurl: string;
}
export interface ParMarketing {
  enddate: string;
  mccode: string;
  mcid: number;
  mclabel: string;
  mcstatus: string;
  mgid: number;
  networkcode: string;
  picturebuttomlefturl: string;
  picturebuttomrighturl: string;
  picturecenterurl: string;
  picturemobileurl: string;
  picturetoplefturl: string;
  picturetoprighturl: string;
  pictureurl: string;
  prcode: string;
  startdate: string;
  offerid: number;
  ofrtype: string;
  ofrid: number;
}

export interface GetParMarketingByCriteriaParams {
  mccode: string;
  mcid: number;
  mclabel: string;
  mcstatus: string;
  networkcode: string;
  prcode: string;
  tpidmanufacturer: number;
  tpidbroker: number;
}

/**
 * @tags Shop Config Controller
 * @summary getParMarketingByCriteria
 */
export function getParMarketingByCriteria(
  params: GetParMarketingByCriteriaParams
) {
  return request.get<AbstractResponse<object, ParMarketingResponse>>(
    `${URL}/api/marketing` +
      prepareQueryParams({
        mccode: params.mccode,
        mcid: params.mcid,
        mclabel: params.mclabel,
        mcstatus: params.mcstatus,
        networkcode: params.networkcode,
        prcode: params.prcode,
        tpidmanufacturer: params.tpidmanufacturer,
        tpidbroker: params.tpidbroker,
      } as any)
  );
}
export interface GetParMarketingDetailByMcidParams {
  mcid: number;
}

/**
 * @tags Shop Config Controller
 * @summary getParMarketingDetailByMcid
 */
export function getParMarketingDetailByMcid(
  params: GetParMarketingDetailByMcidParams
) {
  return request.get<AbstractResponse<ParMarketingResponse, object>>(
    `${URL}/api/marketing/${params.mcid}`
  );
}

export interface AddParMarketingParams {
  request: ParMarketing;
}

/**
 * @tags Shop Config Controller
 * @summary AddParMarketing
 */
export function AddParMarketing(params: AddParMarketingParams) {
  return request.post<AbstractResponse<ParMarketingResponse, object>>(
    `${URL}/api/marketing`,
    params.request
  );
}

export interface UpdateParMarketingParams {
  mcid: number;
  request: ParMarketing;
}

/**
 * @tags Shop Config Controller
 * @summary UpdateParMarketing
 */
export function UpdateParMarketing(params: UpdateParMarketingParams) {
  return request.put<AbstractResponse<ParMarketingResponse, object>>(
    `${URL}/api/marketing/${params.mcid}`,
    params.request
  );
}
export interface UpdateParMarketingStatusParams {
  mcid: number;
  mcstatus: string;
}

/**
 * @tags Shop Config Controller
 * @summary UpdateParMarketingStatus
 */
export function UpdateParMarketingStatus(
  params: UpdateParMarketingStatusParams
) {
  return request.put<AbstractResponse<ParMarketingResponse, object>>(
    `${URL}/api/marketing/${params.mcid}/${params.mcstatus}`
  );
}

export interface RemoveParMarketingParams {
  mcid: number;
}

/**
 * @tags Shop Config Controller
 * @summary RemoveParMarketing
 */
export function RemoveParMarketing(params: RemoveParMarketingParams) {
  return request.delete<AbstractResponse<object, object>>(
    `${URL}/api/marketing/${params.mcid}`
  );
}

export interface AddParMarketingLabelParams {
  mcid: number;
  request: ParMarketingLabel;
}

/**
 * @tags Shop Config Controller
 * @summary AddParMarketingLabel
 */
export function AddParMarketingLabel(params: AddParMarketingLabelParams) {
  return request.post<AbstractResponse<ParMarketingResponse, object>>(
    `${URL}/api/marketing/${params.mcid}/label`,
    params.request
  );
}

export interface UpdateParMarketingLabelParams {
  mcid: number;
  request: ParMarketingLabel;
}

/**
 * @tags Shop Config Controller
 * @summary UpdateParMarketingLabel
 */
export function UpdateParMarketingLabel(params: UpdateParMarketingLabelParams) {
  return request.put<AbstractResponse<ParMarketingResponse, object>>(
    `${URL}/api/marketing/${params.mcid}/label`,
    params.request
  );
}
export interface RemoveParMarketingLabelParams {
  lancode: string;
  mcid: number;
}

/**
 * @tags Shop Config Controller
 * @summary RemoveParMarketingLabel
 */
export function RemoveParMarketingLabel(params: RemoveParMarketingLabelParams) {
  return request.delete<AbstractResponse<object, object>>(
    `${URL}/api/marketing/${params.mcid}/label/${params.lancode}`
  );
}

export interface ParMarketingAssetRequest {
  id: number;
  mcid: number;
  catalogid: number;
  partmethod: string;
  partamount: number;
  partrate: number;
  tpidparticipation: number;
  partnbdays: number;
  rolcode: string;
}

export interface ParMarketingAssetResponse {
  id: number;
  mcid: number;
  catalogid: number;
  partmethod: string;
  partmethodlabel: string;
  partamount: number;
  partrate: number;
  tpidparticipation: number;
  participantreference: string;
  participantname: string;
  partnbdays: number;
  rolcode: string;
  rolcodelabel: string;
}

export interface AddParMarketingAssetParams {
  mcid: number;
  request: ParMarketingAssetRequest;
}

/**
 * @tags Shop Config Controller
 */
export function AddParMarketingAsset(params: AddParMarketingAssetParams) {
  return request.post<AbstractResponse<ParMarketingAssetResponse, object>>(
    `${URL}/api/marketing/${params.mcid}/asset`,
    params.request
  );
}

export interface UpdateParMarketingAssetParams {
  mcid: number;
  request: ParMarketingAssetRequest;
}

/**
 * @tags Shop Config Controller
 * @summary UpdateParMarketingLabel
 */
export function UpdateParMarketingAsset(params: UpdateParMarketingAssetParams) {
  return request.put<AbstractResponse<ParMarketingAssetResponse, object>>(
    `${URL}/api/marketing/${params.mcid}/asset`,
    params.request
  );
}
export interface RemoveParMarketingAssetParams {
  catalogid: number;
  mcid: number;
}

/**
 * @tags Shop Config Controller
 * @summary RemoveParMarketingLabel
 */
export function RemoveParMarketingAsset(params: RemoveParMarketingAssetParams) {
  return request.delete<AbstractResponse<object, object>>(
    `${URL}/api/marketing/${params.mcid}/asset/${params.catalogid}`
  );
}

export interface ParAssetDeprContext {
  coefficient: number;
  combinaisonid: number;
  compcat: string;
  compcatexcluded: string;
  comptype: string;
  comptypeexcluded: string;
  deprcontext: string;
  deprmethod: string;
  durationmonths: number;
  durationyear: number;
  followctduration: boolean;
  mgid: number;
  prcode: string;
  retrieverv: boolean;
  rvevalfixedamount: number;
  rvevalpercentage: number;
  rvevaluationrule: string;
  spreadrv: boolean;
  startdate: string;
}

export interface ParAssetDeprContextResponse {
  coefficient: number;
  combinaisonid: number;
  compcat: string;
  compcatexcluded: string;
  compcatlabel: string;
  comptype: string;
  comptypeexcluded: string;
  comptypelabel: string;
  deprcontext: string;
  deprcontextlabel: string;
  deprmethod: string;
  deprmethodlabel: string;
  durationmonths: number;
  durationyear: number;
  followctduration: boolean;
  mgid: number;
  mgname: string;
  prcode: string;
  retrieverv: boolean;
  rvevalfixedamount: number;
  rvevalpercentage: number;
  rvevaluationrule: string;
  rvevaluationrulelabel: string;
  spreadrv: boolean;
  startdate: string;
  startdatelabel: string;
  flagrecalcdeprsch: boolean;
}
export interface GetAssetDeprContextByCriteriaParams {
  compcat: string;
  comptype: string;
  deprcontext: string;
  deprmethod: string;
  mgid: number;
  prcode: string;
}

/**
 * @tags Accounting Controller
 * @summary getAssetDeprContextByCriteria
 */
export function getAssetDeprContextByCriteria(
  params: GetAssetDeprContextByCriteriaParams
) {
  return request.get<AbstractResponse<object, ParAssetDeprContextResponse>>(
    `${URL}/api/accounting/assetDepreciation` +
      prepareQueryParams({
        compcat: params.compcat,
        comptype: params.comptype,
        deprcontext: params.deprcontext,
        deprmethod: params.deprmethod,
        mgid: params.mgid,
        prcode: params.prcode,
      } as any)
  );
}

export interface CreateAssetDeprContextParams {
  request: ParAssetDeprContext;
}

/**
 * @tags Accounting Controller
 * @summary createAssetDeprContext
 */
export function createAssetDeprContext(params: CreateAssetDeprContextParams) {
  return request.post<AbstractResponse<ParAssetDeprContextResponse, object>>(
    `${URL}/api/accounting/assetDepreciation`,
    params.request
  );
}

export interface UpdateAssetDeprContextParams {
  request: ParAssetDeprContext;
}

/**
 * @tags Accounting Controller
 * @summary updateAssetDeprContext
 */
export function updateAssetDeprContext(params: UpdateAssetDeprContextParams) {
  return request.put<AbstractResponse<ParAssetDeprContextResponse, object>>(
    `${URL}/api/accounting/assetDepreciation`,
    params.request
  );
}

export interface RemoveAssetDeprContextParams {
  combinaisonid: number;
}

/**
 * @tags Accounting Controller
 * @summary removeAssetDeprContext
 */
export function removeAssetDeprContext(params: RemoveAssetDeprContextParams) {
  return request.delete<AbstractResponse<object, object>>(
    `${URL}/api/accounting/assetDepreciation/${params.combinaisonid}`
  );
}

export interface ParAssetAttribute {
  age: string;
  assetcategory: string;
  assetconstructor: string;
  assetfamily: string;
  assetmodel: string;
  assettype: string;
  attid: number;
  balersize: string;
  capacity: string;
  chassisno: string;
  country: string;
  engineno: string;
  flagused: string;
  kwhdegradation: string;
  kwhpower: string;
  kwhproduction: string;
  lift: string;
  nbcampaign: string;
  plateno: string;
  power: string;
  registrationno: string;
  rotorhours: string;
  separatortype: string;
  serialno: string;
  tankcapacity: string;
  threshinghours: string;
  totalbalers: string;
  totalhours: string;
  transmission: string;
  weight: string;
  wheeldrive: string;
  wheeltrack: string;
}

export interface AddAssetattributeParams {
  parAssetAttributeRequest: ParAssetAttribute;
}

/**
 * @tags Par Asset Attribute Controller
 * @summary addAssetattribute
 */
export function addAssetattribute(params: AddAssetattributeParams) {
  return request.post<AbstractResponse<ParAssetAttribute, object>>(
    `${URL}/api/parassetattribute`,
    params.parAssetAttributeRequest
  );
}

export interface GetAssetattributeByIdParams {
  attid: number;
}

/**
 * @tags Par Asset Attribute Controller
 * @summary getAssetattributeById
 */
export function getAssetattributeById(params: GetAssetattributeByIdParams) {
  return request.get<AbstractResponse<ParAssetAttribute, object>>(
    `${URL}/api/parassetattribute/${params.attid}`
  );
}

export interface UpdateAssetattributeParams {
  attid: number;
  parAssetAttributeRequest: ParAssetAttribute;
}

/**
 * @tags Par Asset Attribute Controller
 * @summary UpdateAssetattribute
 */
export function UpdateAssetattribute(params: UpdateAssetattributeParams) {
  return request.put<AbstractResponse<ParAssetAttribute, object>>(
    `${URL}/api/parassetattribute/${params.attid}`,
    params.parAssetAttributeRequest
  );
}

export interface DeleteAssetattributeParams {
  attid: number;
}

/**
 * @tags Par Asset Attribute Controller
 * @summary deleteAssetattribute
 */
export function deleteAssetattribute(params: DeleteAssetattributeParams) {
  return request.delete<AbstractResponse<ParAssetAttribute, object>>(
    `${URL}/api/parassetattribute/${params.attid}`
  );
}

export interface GetAssetattributeByCriteriaParams {
  assetcategory: string;
  assetfamily: string;
  assettype: string;
  attid: number;
  modesearch?: boolean;
}

/**
 * @tags Par Asset Attribute Controller
 * @summary getAssetattributeByCriteria
 */
export function getAssetattributeByCriteria(
  params: GetAssetattributeByCriteriaParams
) {
  return request.get<AbstractResponse<object, ParAssetAttribute>>(
    `${URL}/api/parassetattributebycriteria` +
      prepareQueryParams({
        assetcategory: params.assetcategory,
        assetfamily: params.assetfamily,
        modesearch: params.modesearch,
        assettype: params.assettype,
        attid: params.attid,
      } as any)
  );
}

export interface GetParEntityAttributeByCriteriaParams {
  attcode: string;
  attcodeparent: string;
  entity: string;
  parcode: string;
}

/**
 * @tags par Entity Attribute Controller
 * @summary getParEntityAttributeByCriteria
 */
export function getParEntityAttributeByCriteria(
  params: GetParEntityAttributeByCriteriaParams
) {
  return request.get<AbstractResponse<object, ParEntityAttributeResponse>>(
    `${URL}/api/parentityattribute` +
      prepareQueryParams({
        attcode: params.attcode,
        attcodeparent: params.attcodeparent,
        entity: params.entity,
        parcode: params.parcode,
      } as any)
  );
}

export interface AddParEntityAttributeParams {
  request: ParEntityAttributeRequest;
}

/**
 * @tags par Entity Attribute Controller
 * @summary addParEntityAttribute
 */
export function addParEntityAttribute(params: AddParEntityAttributeParams) {
  return request.post<AbstractResponse<ParEntityAttributeResponse, object>>(
    `${URL}/api/parentityattribute`,
    params.request
  );
}

export interface GetParEntityAttributeParams {
  id: number;
}

export interface ParEntityAttributeResponse {
  attcode: string;
  attcodelabel: string;
  attcodeparent: string;
  attvalueparent: string;
  attcodeparentlabel: string;
  attdatatype: string;
  attdatatypelabel: string;
  attinputtype: string;
  attinputtypelabel: string;
  attnbrows: number;
  colspan: number;
  entity: string;
  entitylabel: string;
  id: number;
  parcode: string;
  parcodelabel: string;
  style: string;
  startdate: string;
  enddate: string;
}

export interface ParEntityAttributeRequest {
  attcode: string;
  attcodeparent: string;
  attdatatype: string;
  attinputtype: string;
  attnbrows: number;
  colspan: number;
  entity: string;
  id: number;
  parcode: string;
  style: string;
}
/**
 * @tags par Entity Attribute Controller
 * @summary getParEntityAttribute
 */
export function getParEntityAttribute(params: GetParEntityAttributeParams) {
  return request.get<AbstractResponse<ParEntityAttributeResponse, object>>(
    `${URL}/api/parentityattribute/${params.id}`
  );
}

export interface UpdateParEntityAttributeParams {
  id: number;
  request: ParEntityAttributeRequest;
}

/**
 * @tags par Entity Attribute Controller
 * @summary updateParEntityAttribute
 */
export function updateParEntityAttribute(
  params: UpdateParEntityAttributeParams
) {
  return request.put<AbstractResponse<ParEntityAttributeResponse, object>>(
    `${URL}/api/parentityattribute/${params.id}`,
    params.request
  );
}

export interface DeleteParEntityAttributeParams {
  id: number;
}

/**
 * @tags par Entity Attribute Controller
 * @summary deleteParEntityAttribute
 */
export function deleteParEntityAttribute(
  params: DeleteParEntityAttributeParams
) {
  return request.delete<AbstractResponse<object, object>>(
    `${URL}/api/parentityattribute/${params.id}`
  );
}

export interface ParEntityAdditionalAttributeResponse {
  assetcategory: string;
  assetcategorylabel: string;
  assetfamily: string;
  assetfamilylabel: string;
  assettype: string;
  assettypelabel: string;
  attcode: string;
  attcodelabel: string;
  defautvalue: string;
  displayorder: number;
  displayposition: string;
  displaypositionlabel: string;
  displaysection: string;
  displaytype: string;
  displaytypelabel: string;
  entity: string;
  entitylabel: string;
  entitytype: string;
  entitytypelabel: string;
  id: number;
  maxvalue: string;
  mgid: number;
  minvalue: string;
  prcode: string;
  prcodelabel: string;
  assetsegment: string;
  assetsegmentlabel: string;
  assetmodel: string;
  assetmodellabel: string;
  startdate: string;
  enddate: string;
  status: string;
  statuslabel: string;
}
export interface ParEntityAdditionalAttributeRequest {
  assetcategory: string;
  assetfamily: string;
  assettype: string;
  assetmodel: string;
  assetsegment: string;
  attcode: string;
  defautvalue: string;
  displayorder: number;
  displayposition: string;
  displaysection: string;
  displaytype: string;
  entity: string;
  entitytype: string;
  enddate: string;
  id: number;
  maxvalue: string;
  mgid: number;
  minvalue: string;
  prcode: string;
  startdate: string;
  status: string;
}
export interface GetParEntityAdditionalAttributeByCriteriaParams {
  assetsegment: string;
  assetcategory: string;
  assetfamily: string;
  assettype: string;
  assetmodel: string;
  entity: string;
  entitytype: string;
  attcode: string;
  mgid: number;
  prcode: string;
  status: string;
}

/**
 * @tags Par Entity Additional Attribute Controller
 * @summary getParEntityAdditionalAttributeByCriteria
 */
export function getParEntityAdditionalAttributeByCriteria(
  params: GetParEntityAdditionalAttributeByCriteriaParams
) {
  return request.get<
    AbstractResponse<object, ParEntityAdditionalAttributeResponse>
  >(
    `${URL}/api/parentityadditionalattribute` +
      prepareQueryParams({
        assetcategory: params.assetcategory,
        assetfamily: params.assetfamily,
        assettype: params.assettype,
        assetsegment: params.assetsegment,
        assetmodel: params.assetmodel,
        entity: params.entity,
        entitytype: params.entitytype,
        mgid: params.mgid,
        prcode: params.prcode,
        status: params.status,
        attcode: params.attcode,
      } as any)
  );
}

export interface AddParEntityAdditionalAttributeParams {
  request: ParEntityAdditionalAttributeRequest;
}

/**
 * @tags Par Entity Additional Attribute Controller
 * @summary addParEntityAdditionalAttribute
 */
export function addParEntityAdditionalAttribute(
  params: AddParEntityAdditionalAttributeParams
) {
  return request.post<
    AbstractResponse<ParEntityAdditionalAttributeResponse, object>
  >(`${URL}/api/parentityadditionalattribute`, params.request);
}

export interface GetParEntityAdditionalAttributeParams {
  id: number;
}

/**
 * @tags Par Entity Additional Attribute Controller
 * @summary getParEntityAdditionalAttribute
 */
export function getParEntityAdditionalAttribute(
  params: GetParEntityAdditionalAttributeParams
) {
  return request.get<
    AbstractResponse<ParEntityAdditionalAttributeResponse, object>
  >(`${URL}/api/parentityadditionalattribute/${params.id}`);
}

export interface UpdateParEntityAdditionalAttributeParams {
  id: number;
  request: ParEntityAdditionalAttributeRequest;
}

/**
 * @tags Par Entity Additional Attribute Controller
 * @summary updateParEntityAdditionalAttribute
 */
export function updateParEntityAdditionalAttribute(
  params: UpdateParEntityAdditionalAttributeParams
) {
  return request.put<
    AbstractResponse<ParEntityAdditionalAttributeResponse, object>
  >(`${URL}/api/parentityadditionalattribute/${params.id}`, params.request);
}

export interface DeleteParEntityAdditionalAttributeParams {
  id: number;
}

/**
 * @tags Par Entity Additional Attribute Controller
 * @summary deleteParEntityAdditionalAttribute
 */
export function deleteParEntityAdditionalAttribute(
  params: DeleteParEntityAdditionalAttributeParams
) {
  return request.delete<AbstractResponse<object, object>>(
    `${URL}/api/parentityadditionalattribute/${params.id}`
  );
}

export interface GetAssetRvAmountListParams {
  assetid: number;
  prcode: string;
  assettype: string;
  assetcat: string;
  assetamount: number;
  filters: prFilteringCriteria;
}

export interface ParAssetResidualValue {
  assetcategory: string;
  assettype: string;
  mgid: number;
  monthsmax: number;
  monthsmin: number;
  prcode: string;
  rvevaluationmode: string;
  rvfixedamount: number;
  rvid: number;
  rvpercentage: number;
  trg: number;
  rvtype: string;
  monthdecrease: number;
  rvstartmethod: string;
  countrvid?: number;
}

export interface GetParAssetRVByCriteriaParams {
  assetcategory: string;
  assettype: string;
  mgid: number;
  prcode: string;
  rvtype: string;
}

export interface CalculateRVAmountResponse {
  mgid: number;
  prcode: string;
  assettype: string;
  assetcat: string;
  assetamount: number;
  duration: number;
  assetrvamount: number;
}

export interface GetCalculateAssetRvAmountParams {
  prcode: string;
  assettype: string;
  assetcat: string;
  assetamount: number;
  duration: number;
}

export function calculateAssetRvAmount(
  params: GetCalculateAssetRvAmountParams
) {
  return request.get<AbstractResponse<CalculateRVAmountResponse, object>>(
    `${URL}/api/calculateAssetRvAmount` +
      prepareQueryParams({
        prcode: params.prcode,
        assettype: params.assettype,
        assetcat: params.assetcat,
        assetamount: params.assetamount,
        duration: params.duration,
      } as any)
  );
}

export function getAssetRvAmountList(params: GetAssetRvAmountListParams) {
  return request.post<AbstractResponse<AssetRVAmountResponse, object>>(
    `${URL}/api/getAssetRvAmountList` +
      prepareQueryParams({
        assetid: params.assetid,
        prcode: params.prcode,
        assettype: params.assettype,
        assetcat: params.assetcat,
        assetamount: params.assetamount,
      } as any),
    params.filters
  );
}

export interface FilteringCriteria {
  critcode: string;
  critvalue: string;
}

export interface AssetUseCriteria {
  assetfamily: string;
  assettype: string;
  assetcategory: string;
  catalogid: number;
  attcode: string;
  attvalue: number;
}

export interface prFilteringCriteria {
  assetUseCriteria: Array<AssetUseCriteria>;
  assetRVCriteria: Array<AssetRVCriteria>;
  flagApplyAssetUse?: boolean;
  flagApplyAttributesExtendDurationValues?: boolean;
  flagApplyAttributesExtendFirstRentalValues?: boolean;
  flagApplyAttributesExtendRVValues?: boolean;
  flagApplyAttributesExtendRateValues?: boolean;
  flagApplyExtendDurationValues?: boolean;
  flagApplyExtendFirstRentalValues?: boolean;
  flagApplyExtendRVValues?: boolean;
  flagApplyExtendRateValues?: boolean;
  offerCriteria: Array<FilteringCriteria>;
  prcode: string;
  tpid: number;
  tpidbroker: number;
  tpidmanufacturer: number;
}

export interface ParassetfvcontextRequest {
  assetcategory: string;
  assetfamily: string;
  assettype: string;
  assetsegment: string;
  assetmodel: string;
  catalogid: number;
  contextcode: string;
  contextorigin: string;
  contextstatus: string;
  durationmax: number;
  durationmin: number;
  offerid: number;
  ofrid: number;
  ofrtype: string;
  parcontextid: number;
  prcode: string;
}

export interface ParassetfvcontextResponse {
  assetcategory: string;
  assetcategorylabel: string;
  assetfamily: string;
  assetfamilylabel: string;
  assettype: string;
  assettypelabel: string;
  assetsegment: string;
  assetmodel: string;
  assetsegmentlabel: string;
  assetmodellabel: string;
  catalogid: number;
  cataloglabel: string;
  contextcode: string;
  contextcodelabel: string;
  contextcodeoriginelabel: string;

  contextorigin: string;
  contextoriginlabel: string;
  contextstatus: string;
  contextstatuslabel: string;
  durationmax: number;
  durationmin: number;
  offerid: number;
  ofrid: number;
  ofrtype: string;
  ofrtypelabel: string;
  parcontextid: number;
  parcontextidorigine: number;
  flagreplace: boolean;
  prcode: string;
  enddate: string;
  startdate: string;
}

export interface ParassetfvcontextuseRequest {
  attcode: string;
  fvuseid: number;
  parcontextid: number;
  usevaluemax: number;
  usevaluemin: number;
}

export interface ParassetfvcontextuseResponse {
  attcode: string;
  fvuseid: number;
  parcontextid: number;
  usevaluemax: number;
  usevaluemin: number;
}
export interface ParassetfvvalueRequest {
  fvevaluationmode: string;
  fvfixedamount: number;
  fvid: number;
  fvpercentage: number;
  fvstartmethod: string;
  monthdecrease: number;
  monthsmax: number;
  monthsmin: number;
  parcontextid: number;
}

export interface ParassetfvvalueResponse {
  fvevaluationmode: string;
  fvfixedamount: number;
  fvid: number;
  fvpercentage: number;
  fvstartmethod: string;
  monthdecrease: number;
  monthsmax: number;
  monthsmin: number;
  parcontextid: number;
}

export interface ParassetfvvalueuseRequest {
  attcode: string;
  degradationcoef: number;
  degradationfixedamount: number;
  fvid: number;
  fvuseid: number;
  parcontextid: number;
  usedegradationmethod: string;
  usevaluemax: number;
  usevaluemin: number;
}

export interface ParassetfvvalueuseResponse {
  attcode: string;
  degradationcoef: number;
  degradationfixedamount: number;
  fvid: number;
  fvuseid: number;
  parcontextid: number;
  usedegradationmethod: string;
  usevaluemax: number;
  usevaluemin: number;
}

export interface ParEntityAttributeGroup {
  attcodechild: string;
  attcodeparent: string;
  gpid: number;
}

export interface ParEntityAttributeGroupResponse {
  attcodechild: string;
  attcodechildlabel: string;
  attcodeparent: string;
  gpid: number;
}

export interface GetParassetfvcontextByCriteriaParams {
  assetcategory: string;
  assetfamily: string;
  assettype: string;
  assetsegment: string;
  assetmodel: string;
  catalogid: number;
  contextcode: string;
  contextorigin: string;
  contextstatus: string;
  offerid: number;
  prcode: string;
  parcontextid: number;
}

/**
 * @tags Par Asset Future Value Controller
 * @summary getParassetfvcontextByCriteria
 */
export function getParassetfvcontextByCriteria(
  params: GetParassetfvcontextByCriteriaParams
) {
  return request.get<AbstractResponse<object, ParassetfvcontextResponse>>(
    `${URL}/api/parassetfvcontext` +
      prepareQueryParams({
        assetcategory: params.assetcategory,
        assetfamily: params.assetfamily,
        assettype: params.assettype,
        assetsegment: params.assetsegment,
        assetmodel: params.assetmodel,
        catalogid: params.catalogid,
        contextcode: params.contextcode,
        contextorigin: params.contextorigin,
        contextstatus: params.contextstatus,
        offerid: params.offerid,
        prcode: params.prcode,
        parcontextid: params.parcontextid,
      } as any)
  );
}

export interface AddParassetfvcontextParams {
  request: ParassetfvcontextRequest;
}

/**
 * @tags Par Asset Future Value Controller
 * @summary addParassetfvcontext
 */
export function addParassetfvcontext(params: AddParassetfvcontextParams) {
  return request.post<AbstractResponse<ParassetfvcontextResponse, object>>(
    `${URL}/api/parassetfvcontext`,
    params.request
  );
}

export interface AddParAssetFvContextCriteriaParams {
  request: ParAssetFvContextCriteria;
  contextid: number;
}

/**
 * @tags Par Asset Future Value Controller
 * @summary addParassetfvcontext
 */
export function addParAssetFvContextCriteria(
  params: AddParAssetFvContextCriteriaParams
) {
  return request.post<AbstractResponse<ParassetfvcontextResponse, object>>(
    `${URL}/api/parassetfvcontext/${params.contextid}/criteria`,
    params.request
  );
}

export interface GetParAssetFvContextCriteriaListParams {
  contextid?: number;
}

/**
 * @tags Par Asset Future Value Controller
 * @summary getParassetfvcontextbyId
 */
export function getParAssetFvContextCriteriaList(
  params: GetParassetfvcontextbyIdParams
) {
  return request.get<AbstractResponse<ParassetfvcontextResponse, object>>(
    `${URL}/api/parassetfvcontext/${params.contextid}/criteria` +
      prepareQueryParams({ contextid: params.contextid } as any)
  );
}

export interface DeleteParassetfvcontextCriteriaParams {
  contextid: number;
  criid: number;
}

/**
 * @tags Par Asset Future Value Controller
 * @summary deleteParassetfvcontext
 */
export function removeParAssetFvContextCriteria(
  params: DeleteParassetfvcontextCriteriaParams
) {
  return request.delete<AbstractResponse<object, object>>(
    `${URL}/api/parassetfvcontext/${params.contextid}/criteria/${params.criid}`
  );
}

export interface GetParassetfvcontextbyIdParams {
  contextid?: number;
}

/**
 * @tags Par Asset Future Value Controller
 * @summary getParassetfvcontextbyId
 */
export function getParassetfvcontextbyId(
  params: GetParassetfvcontextbyIdParams
) {
  return request.get<AbstractResponse<ParassetfvcontextResponse, object>>(
    `${URL}/api/parassetfvcontext/${params.contextid}` +
      prepareQueryParams({ contextid: params.contextid } as any)
  );
}

export interface UpdateParassetfvcontextParams {
  contextid: number;
  request: ParassetfvcontextRequest;
}

/**
 * @tags Par Asset Future Value Controller
 * @summary updateParassetfvcontext
 */
export function updateParassetfvcontext(params: UpdateParassetfvcontextParams) {
  return request.put<AbstractResponse<ParassetfvcontextResponse, object>>(
    `${URL}/api/parassetfvcontext/${params.contextid}`,
    params.request
  );
}

export interface DeleteParassetfvcontextParams {
  contextid: number;
}

/**
 * @tags Par Asset Future Value Controller
 * @summary deleteParassetfvcontext
 */
export function deleteParassetfvcontext(params: DeleteParassetfvcontextParams) {
  return request.delete<AbstractResponse<object, object>>(
    `${URL}/api/parassetfvcontext/${params.contextid}`
  );
}

export interface UpdateParassetfvcontextstatusParams {
  contextid: number;
  status: string;
}

/**
 * @tags Par Asset Future Value Controller
 * @summary updateParassetfvcontextstatus
 */
export function updateParassetfvcontextstatus(
  params: UpdateParassetfvcontextstatusParams
) {
  return request.put<AbstractResponse<ParassetfvcontextResponse, object>>(
    `${URL}/api/parassetfvcontext/${params.contextid}/${params.status}`
  );
}
export interface AddParassetfvcontextuseParams {
  request: ParassetfvcontextuseRequest;
}

/**
 * @tags Par Asset Future Value Controller
 * @summary addParassetfvcontextuse
 */
export function addParassetfvcontextuse(params: AddParassetfvcontextuseParams) {
  return request.post<AbstractResponse<ParassetfvcontextuseResponse, object>>(
    `${URL}/api/Parassetfvcontextuse`,
    params.request
  );
}

export interface UpdateParassetfvcontextuseParams {
  fvuseid: number;
  request: ParassetfvcontextuseRequest;
}

/**
 * @tags Par Asset Future Value Controller
 * @summary updateParassetfvcontextuse
 */
export function updateParassetfvcontextuse(
  params: UpdateParassetfvcontextuseParams
) {
  return request.put<AbstractResponse<ParassetfvcontextuseResponse, object>>(
    `${URL}/api/Parassetfvcontextuse/${params.fvuseid}`,
    params.request
  );
}

export interface DeleteParassetfvcontextuseParams {
  fvuseid: number;
}

/**
 * @tags Par Asset Future Value Controller
 * @summary deleteParassetfvcontextuse
 */
export function deleteParassetfvcontextuse(
  params: DeleteParassetfvcontextuseParams
) {
  return request.delete<AbstractResponse<object, object>>(
    `${URL}/api/Parassetfvcontextuse/${params.fvuseid}`
  );
}

export interface GetParassetfvcontextuseByContextidParams {
  parcontextid: number;
}

/**
 * @tags Par Asset Future Value Controller
 * @summary getParassetfvcontextuseByContextid
 */
export function getParassetfvcontextuseByContextid(
  params: GetParassetfvcontextuseByContextidParams
) {
  return request.get<AbstractResponse<object, ParassetfvcontextuseResponse>>(
    `${URL}/api/Parassetfvcontextuse/${params.parcontextid}`
  );
}

export interface AddParassetfvvalueParams {
  request: ParassetfvvalueRequest;
}

/**
 * @tags Par Asset Future Value Controller
 * @summary addParassetfvvalue
 */
export function addParassetfvvalue(params: AddParassetfvvalueParams) {
  return request.post<AbstractResponse<ParassetfvvalueResponse, object>>(
    `${URL}/api/Parassetfvvalue`,
    params.request
  );
}

export interface UpdateParassetfvvalueParams {
  fvid: number;
  request: ParassetfvvalueRequest;
}

/**
 * @tags Par Asset Future Value Controller
 * @summary updateParassetfvvalue
 */
export function updateParassetfvvalue(params: UpdateParassetfvvalueParams) {
  return request.put<AbstractResponse<ParassetfvvalueResponse, object>>(
    `${URL}/api/Parassetfvvalue/${params.fvid}`,
    params.request
  );
}

export interface DeleteParassetfvvalueParams {
  fvid: number;
}

/**
 * @tags Par Asset Future Value Controller
 * @summary deleteParassetfvvalue
 */
export function deleteParassetfvvalue(params: DeleteParassetfvvalueParams) {
  return request.delete<AbstractResponse<object, object>>(
    `${URL}/api/Parassetfvvalue/${params.fvid}`
  );
}

export interface GetParassetfvvalueByContextidParams {
  parcontextid: number;
}

/**
 * @tags Par Asset Future Value Controller
 * @summary getParassetfvvalueByContextid
 */
export function getParassetfvvalueByContextid(
  params: GetParassetfvvalueByContextidParams
) {
  return request.get<AbstractResponse<object, ParassetfvvalueResponse>>(
    `${URL}/api/Parassetfvvalue/${params.parcontextid}`
  );
}

export interface AddParassetfvvalueuseParams {
  request: ParassetfvvalueuseRequest;
}

/**
 * @tags Par Asset Future Value Controller
 * @summary addParassetfvvalueuse
 */
export function addParassetfvvalueuse(params: AddParassetfvvalueuseParams) {
  return request.post<AbstractResponse<ParassetfvvalueuseResponse, object>>(
    `${URL}/api/Parassetfvvalueuse`,
    params.request
  );
}

export interface GetParassetfvvalueuseByContextidParams {
  fvid: number;
}

/**
 * @tags Par Asset Future Value Controller
 * @summary getParassetfvvalueuseByContextid
 */
export function getParassetfvvalueuseByContextid(
  params: GetParassetfvvalueuseByContextidParams
) {
  return request.get<AbstractResponse<object, ParassetfvvalueuseResponse>>(
    `${URL}/api/Parassetfvvalueuse/${params.fvid}`
  );
}

export interface DeleteParassetfvvalueuseParams {
  fvuseid: number;
}

/**
 * @tags Par Asset Future Value Controller
 * @summary deleteParassetfvvalueuse
 */
export function deleteParassetfvvalueuse(
  params: DeleteParassetfvvalueuseParams
) {
  return request.delete<AbstractResponse<object, object>>(
    `${URL}/api/Parassetfvvalueuse/${params.fvuseid}`
  );
}

export interface UpdateParassetfvvalueuseParams {
  fvuseid: number;
  request: ParassetfvvalueuseRequest;
}

/**
 * @tags Par Asset Future Value Controller
 * @summary updateParassetfvvalueuse
 */
export function updateParassetfvvalueuse(
  params: UpdateParassetfvvalueuseParams
) {
  return request.put<AbstractResponse<ParassetfvvalueuseResponse, object>>(
    `${URL}/api/Parassetfvvalueuse/${params.fvuseid}`,
    params.request
  );
}
export interface ParAssetFvContextDegradationRequest {
  attcode: string;
  degradationcoef: number;
  degradationfixedamount: number;
  fvuseid: number;
  parcontextid: number;
  usedegradationmethod: string;
  usevaluemax: number;
  usevaluemin: number;
}
export interface ParAssetFvContextDegradationResponse {
  attcode: string;
  degradationcoef: number;
  degradationfixedamount: number;
  fvuseid: number;
  parcontextid: number;
  usedegradationmethod: string;
  usevaluemax: number;
  usevaluemin: number;
}

export interface AddParAssetFvContextDegradationParams {
  request: ParAssetFvContextDegradationRequest;
}

/**
 * @tags Par Asset Future Value Controller
 * @summary addParAssetFvContextDegradation
 */
export function addParAssetFvContextDegradation(
  params: AddParAssetFvContextDegradationParams
) {
  return request.post<
    AbstractResponse<ParAssetFvContextDegradationResponse, object>
  >(`${URL}/api/Parassetfvcontextdegradation`, params.request);
}

export interface DeleteParAssetFvContextDegradationParams {
  fvuseid: number;
}

/**
 * @tags Par Asset Future Value Controller
 * @summary deleteParAssetFvContextDegradation
 */
export function deleteParAssetFvContextDegradation(
  params: DeleteParAssetFvContextDegradationParams
) {
  return request.delete<AbstractResponse<object, object>>(
    `${URL}/api/Parassetfvcontextdegradation/${params.fvuseid}`
  );
}
export interface GetParassetfvcontextdegradationByParcontextidParams {
  parcontextid: number;
}

/**
 * @tags Par Asset Future Value Controller
 * @summary getParassetfvcontextdegradationByParcontextid
 */
export function getParassetfvcontextdegradationByParcontextid(
  params: GetParassetfvcontextdegradationByParcontextidParams
) {
  return request.get<
    AbstractResponse<object, ParAssetFvContextDegradationResponse>
  >(`${URL}/api/Parassetfvcontextdegradation/${params.parcontextid}`);
}
export interface UpdateParAssetFvContextDegradationParams {
  fvuseid: number;
  request: ParAssetFvContextDegradationRequest;
}

/**
 * @tags Par Asset Future Value Controller
 * @summary updateParAssetFvContextDegradation
 */
export function updateParAssetFvContextDegradation(
  params: UpdateParAssetFvContextDegradationParams
) {
  return request.put<
    AbstractResponse<ParAssetFvContextDegradationResponse, object>
  >(
    `${URL}/api/Parassetfvcontextdegradation/${params.fvuseid}`,
    params.request
  );
}

export interface GetAssetCatalogUpgradeListParams {
  catalogid: number;
}

/**
 * @tags Asset Catalog Controller
 * @summary getAssetCatalogUpgradeList
 */
export function getAssetCatalogUpgradeList(
  params: GetAssetCatalogUpgradeListParams
) {
  return request.get<AbstractResponse<object, AssetCatalogUpgradeResponse>>(
    `${URL}/api/assetCatalog/${params.catalogid}/upgrade`
  );
}

export interface AddAssetCatalogUpgradeParams {
  catalogid: number;
  req: ParAssetCatalogUpgrade;
}

/**
 * @tags Asset Catalog Controller
 * @summary addAssetCatalogUpgrade
 */
export function addAssetCatalogUpgrade(params: AddAssetCatalogUpgradeParams) {
  return request.post<AbstractResponse<object, object>>(
    `${URL}/api/assetCatalog/${params.catalogid}/upgrade`,
    params.req
  );
}

export interface RemoveAssetCatalogUpgradeParams {
  catalogid: number;
  upid: number;
}

/**
 * @tags Asset Catalog Controller
 * @summary removeAssetCatalogUpgrade
 */
export function removeAssetCatalogUpgrade(
  params: RemoveAssetCatalogUpgradeParams
) {
  return request.delete<AbstractResponse<object, object>>(
    `${URL}/api/assetCatalog/${params.catalogid}/upgrade/${params.upid}`
  );
}

export interface GetAssetCatalogDowngradeListParams {
  catalogid: number;
}

/**
 * @tags Asset Catalog Controller
 * @summary getAssetCatalogDowngradeList
 */
export function getAssetCatalogDowngradeList(
  params: GetAssetCatalogDowngradeListParams
) {
  return request.get<AbstractResponse<object, AssetCatalogUpgradeResponse>>(
    `${URL}/api/assetCatalog/${params.catalogid}/downgrade`
  );
}
export interface ParAssetCatalogOptionLabel {
  labelid: number;
  lancode: string;
  optdescription: string;
  optid: number;
  optlabel: string;
  opttaglabel: string;
}

export interface GetAssetCatalogOptionLabelListParams {
  catalogid: number;
  optid: number;
}

/**
 * @tags Asset Catalog Controller
 * @summary getAssetCatalogOptionLabelList
 */
export function getAssetCatalogOptionLabelList(
  params: GetAssetCatalogOptionLabelListParams
) {
  return request.get<AbstractResponse<object, ParAssetCatalogOptionLabel>>(
    `${URL}/api/assetCatalog/${params.catalogid}/option/${params.optid}/label`
  );
}

export interface AddAssetCatalogOptionLabelParams {
  catalogid: number;
  optid: number;
  req: ParAssetCatalogOptionLabel;
}

/**
 * @tags Asset Catalog Controller
 * @summary addAssetCatalogOptionLabel
 */
export function addAssetCatalogOptionLabel(
  params: AddAssetCatalogOptionLabelParams
) {
  return request.post<AbstractResponse<object, object>>(
    `${URL}/api/assetCatalog/${params.catalogid}/option/${params.optid}/label`,
    params.req
  );
}

export interface UpdateAssetCatalogOptionLabelParams {
  catalogid: number;
  labelid: number;
  optid: number;
  req: ParAssetCatalogOptionLabel;
}

/**
 * @tags Asset Catalog Controller
 * @summary updateAssetCatalogOptionLabel
 */
export function updateAssetCatalogOptionLabel(
  params: UpdateAssetCatalogOptionLabelParams
) {
  return request.put<AbstractResponse<object, object>>(
    `${URL}/api/assetCatalog/${params.catalogid}/option/${params.optid}/label/${params.labelid}`,
    params.req
  );
}

export interface RemoveAssetCatalogOptionLabelParams {
  catalogid: number;
  labelid: number;
  optid: number;
}

/**
 * @tags Asset Catalog Controller
 * @summary removeAssetCatalogOptionLabel
 */
export function removeAssetCatalogOptionLabel(
  params: RemoveAssetCatalogOptionLabelParams
) {
  return request.delete<AbstractResponse<object, object>>(
    `${URL}/api/assetCatalog/${params.catalogid}/option/${params.optid}/label/${params.labelid}`
  );
}

export interface ParAssetCatalogOptionConflict {
  catalogid: number;
  confid: number;
  optid: number;
  optidconflict: number;
}

export interface AddAssetCatalogOptionConflictParams {
  catalogid: number;
  optid: number;
  req: ParAssetCatalogOptionConflict;
}

/**
 * @tags Asset Catalog Controller
 * @summary addAssetCatalogOptionConflict
 */
export function addAssetCatalogOptionConflict(
  params: AddAssetCatalogOptionConflictParams
) {
  return request.post<AbstractResponse<object, object>>(
    `${URL}/api/assetCatalog/${params.catalogid}/option/${params.optid}/conflict`,
    params.req
  );
}

export interface RemoveAssetCatalogOptionConflictParams {
  catalogid: number;
  confid: number;
  optid: number;
}

/**
 * @tags Asset Catalog Controller
 * @summary removeAssetCatalogOptionConflict
 */
export function removeAssetCatalogOptionConflict(
  params: RemoveAssetCatalogOptionConflictParams
) {
  return request.delete<AbstractResponse<object, object>>(
    `${URL}/api/assetCatalog/${params.catalogid}/option/${params.optid}/conflict/${params.confid}`
  );
}

export interface ParAssetCatalogOptionConflictResponse {
  catalogid: number;
  confid: number;
  optconflictlabel: string;
  optid: number;
  optidconflict: number;
}

export interface GetAssetCatalogOptionConflictListParams {
  catalogid: number;
  optid: number;
}

/**
 * @tags Asset Catalog Controller
 * @summary getAssetCatalogOptionConflictList
 */
export function getAssetCatalogOptionConflictList(
  params: GetAssetCatalogOptionConflictListParams
) {
  return request.get<
    AbstractResponse<object, ParAssetCatalogOptionConflictResponse>
  >(
    `${URL}/api/assetCatalog/${params.catalogid}/option/${params.optid}/conflict`
  );
}

export interface UpdateAssetCatalogOptionStatusParams {
  catalogid: number;
  optid: number;
  optstatus: string;
}

/**
 * @tags Asset Catalog Controller
 * @summary updateAssetCatalogOptionStatus
 */
export function updateAssetCatalogOptionStatus(
  params: UpdateAssetCatalogOptionStatusParams
) {
  return request.put<AbstractResponse<object, object>>(
    `${URL}/api/assetCatalog/${params.catalogid}/option/${params.optid}/${params.optstatus}`
  );
}

export interface AssetFVApplicableContextRequest {
  useCondition: Array<AssetUseConditionRequest>;
  attributeList: Array<FilteringCriteria>;
  assetcategory: string;
  assetfamily: string;
  assettype: string;
  assetsegment: string;
  assetmodel: string;
  catalogid: number;
  duration: number;
  mode: string;
  offerid: number;
  ofrid: number;
  ofrtype: string;
  prcode: string;
}

export interface AssetFVApplicableContextResponse {
  contextcode: string;
  contextcodelabel: string;
  contextorigin: string;
  contextoriginlabel: string;
  duration: number;
  offerid: number;
  offerlabel: string;
  ofrid: number;
  ofrlabel: string;
  ofrtype: string;
  ofrtypelabel: string;
  parcontextid: number;
  prcode: string;
  prcodelabel: string;
}

export interface ParAssetFvContextCriteriaResponse {
  applicationrule: string;
  criid: number;
  critcode: string;
  critcodelabel: string;
  critoperand: string;
  critvalue: string;
  critvaluelabel: string;
  critvaluemax: string;
  listvalue: string;
  parcontextid: number;
}

export interface ParAssetFvContextCriteria {
  applicationrule: string;
  criid: number;
  critcode: string;
  critoperand: string;
  critvalue: string;
  critvaluemax: string;
  listvalue: string;
  parcontextid: number;
}

export interface GetAssetFVApplicableContextParams {
  request: AssetFVApplicableContextRequest;
}

/**
 * @tags Asset Controller
 * @summary getFVApplicableContext
 */
export function getFVApplicableContext(
  params: GetAssetFVApplicableContextParams
) {
  return request.post<
    AbstractResponse<object, AssetFVApplicableContextResponse>
  >(`${URL}/api/asset/futureValue/applicableContext`, params.request);
}

export interface AddParEntityAttributeGroupParams {
  request: ParEntityAttributeGroup;
}

/**
 * @tags par Entity Attribute Controller
 * @summary addParEntityAttributeGroup
 */
export function addParEntityAttributeGroup(
  params: AddParEntityAttributeGroupParams
) {
  return request.post<AbstractResponse<object, object>>(
    `${URL}/api/parentityattributeGroup`,
    params.request
  );
}

export interface GetParEntityAttributeGroupByParentParams {
  attcodeparent: string;
}

/**
 * @tags par Entity Attribute Controller
 * @summary getParEntityAttributeGroupByParent
 */
export function getParEntityAttributeGroupByParent(
  params: GetParEntityAttributeGroupByParentParams
) {
  return request.get<AbstractResponse<object, ParEntityAttributeGroupResponse>>(
    `${URL}/api/parentityattributeGroup/${params.attcodeparent}`
  );
}

export interface RemoveParEntityAttributeGroupParams {
  gpid: number;
}

/**
 * @tags par Entity Attribute Controller
 * @summary removeParEntityAttributeGroup
 */
export function removeParEntityAttributeGroup(
  params: RemoveParEntityAttributeGroupParams
) {
  return request.delete<AbstractResponse<object, object>>(
    `${URL}/api/parentityattributeGroup/${params.gpid}`
  );
}

export interface JobExecutionResponse {
  code: string;
  description: string;
  errorfile: string;
  jobid: number;
  logfile: string;
  message: string;
  outputfile: string;
  servicename: string;
}

export interface GetMgParAssetCatalogByCatalogidParams {
  catalogid: number;
}

/**
 * @tags Asset Catalog Controller
 * @summary getMgParAssetCatalogByCatalogid
 */
export function getMgParAssetCatalogByCatalogid(
  params: GetMgParAssetCatalogByCatalogidParams
) {
  return request.get<AbstractResponse<object, MgParAssetCatalogResponse>>(
    `${URL}/api/assetCatalog/${params.catalogid}/mgcompany`
  );
}

export interface AddMgParAssetCatalogParams {
  catalogid: number;
  request: MgParAssetCatalog;
}

/**
 * @tags Asset Catalog Controller
 * @summary addMgParAssetCatalog
 */
export function addMgParAssetCatalog(params: AddMgParAssetCatalogParams) {
  return request.post<AbstractResponse<object, object>>(
    `${URL}/api/assetCatalog/${params.catalogid}/mgcompany`,
    params.request
  );
}

export interface RemoveMgParAssetCatalogParams {
  catalogid: number;
  filterid: number;
}

/**
 * @tags Asset Catalog Controller
 * @summary removeMgParAssetCatalog
 */
export function removeMgParAssetCatalog(params: RemoveMgParAssetCatalogParams) {
  return request.delete<AbstractResponse<object, object>>(
    `${URL}/api/assetCatalog/${params.catalogid}/mgcompany/${params.filterid}`
  );
}

export interface importParAssetCatalogFileParams {
  filename: string;
  targetstatus: string;
}

/**
 * @tags Par Asset Catalog Controller
 * @summary importParListFile
 */
export function importParAssetCatalogFile(
  params: importParAssetCatalogFileParams
) {
  return request.post<JobExecutionResponse>(
    `${URL}/api/importParAssetCatalogFile` +
      prepareQueryParams({
        filename: params.filename,
        targetStatus: params.targetstatus,
      } as any)
  );
}

export interface ImportAssetAttributeFileParams {
  filename: string;
}

/**
 * @tags Par Asset Attributes File Controller
 * @summary importAssetAttributeFile
 */
export function importAssetAttributeFile(
  params: ImportAssetAttributeFileParams
) {
  return request.post<JobExecutionResponse>(
    `${URL}/api/importParAssetAttFile` +
      prepareQueryParams({ filename: params.filename } as any)
  );
}

/**
 * @tags Par Asset Catalog Controller
 * @summary getFiles
 */
export function getFiles() {
  return request.get<AbstractResponse<object, string>>(`${URL}/api/files`);
}

export interface importParAssetFVContextFileParams {
  filename: string;
  targetstatus: string;
}

/**
 * @tags Par Asset Catalog Controller
 * @summary importParListFile
 */
export function importParAssetFVContextFile(
  params: importParAssetCatalogFileParams
) {
  return request.post<JobExecutionResponse>(
    `${URL}/api/importParAssetFVContextFile` +
      prepareQueryParams({
        filename: params.filename,
        targetStatus: params.targetstatus,
      } as any)
  );
}
